export default {
  'viewWireFileSummary.overviewInfo': 'Overview Information',
  'viewWireFileSummary.importDate': 'import date',
  'viewWireFileSummary.importedBy': 'imported by',
  'viewWireFileSummary.map': 'map type',
  'viewWireFileSummary.fileTotal': 'file total',
  'viewWireFileSummary.importTotal': 'import total',
  'viewWireFileSummary.amountTotal': 'total amount',
  'viewWireFileSummary.filename': 'filename',

  'viewWireFileSummary.importInfo': 'Import Information',
  'viewWireFileSummary.totalRecords': 'total records',
  'viewWireFileSummary.successRecords': 'good records',
  'viewWireFileSummary.failRecords': 'failed records',
  'viewWireFileSummary.possibleDuplicates': 'possible duplicates',
  'viewWireFileSummary.importMessages': 'import messages',
  'viewWireFileSummary.importDetails': 'import details',
  'viewWireFileSummary.infoMessage': 'Displaying first 20 upload messages only'
};
